import { MarketingConsentConfig } from '../reducers/marketing-consent-reducer';
import { Action, ThunkAction } from '../types';
import { captureException, captureMessage } from '../utilities/analytics/error-reporting';
import type { SeverityLevel } from '@sentry/react';

export type MarketingConsentAction = {
  type: 'UPDATE_MARKETING_CONSENT_CONFIG';
  config: MarketingConsentConfig;
};

export const updateMarketingConsentConfig = (config: MarketingConsentConfig): Action => ({
  type: 'UPDATE_MARKETING_CONSENT_CONFIG',
  config,
});

export const fetchConsentConfig =
  (email: string): ThunkAction =>
  dispatch => {
    return fetch('/rest/marketing-consent/config', {
      method: 'POST',
      credentials: 'omit',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    })
      .then(response => {
        if (response.status === 200) {
          return response
            .json()
            .then((cfg: MarketingConsentConfig) => dispatch(updateMarketingConsentConfig(cfg)));
        } else if (response.status === 204) {
          // No response from ConsentHub for some reason
          const level: SeverityLevel = 'warning';
          captureMessage(
            'Unable to retrieve marketing consent config',
            {
              status: response.status,
              reason: 'no_content',
            },
            level
          );
        } else if (response.status === 400) {
          // Signup was unable to extract IP
          const level: SeverityLevel = 'warning';
          captureMessage(
            'Unable to retrieve marketing consent config',
            {
              status: response.status,
              reason: 'cannot_extract_ip',
            },
            level
          );
        } else {
          return response.text().then(error => {
            throw new Error(error || response.statusText);
          });
        }
      })
      .catch(captureException);
  };
